export default __webpack_public_path__ + "static/media/right-bottom.c2313fb1.png";